import serviceDev from './service.dev';
import serviceProduction from './service.prod';
import serviceStaging from './service.staging';
import runtimeConfig from '../runtime';


let config = serviceDev;

if (runtimeConfig.REACT_APP_ENV === 'dev')
{
    config = serviceDev;
} else if (runtimeConfig.REACT_APP_ENV === 'staging')
{
    config = serviceStaging;
} else
{
    config = serviceProduction;
}

export default config;
